import { render, staticRenderFns } from "./habilitarCadastramentoAnolectivo.vue?vue&type=template&id=0056272a&"
import script from "./habilitarCadastramentoAnolectivo.vue?vue&type=script&lang=js&"
export * from "./habilitarCadastramentoAnolectivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports